import { CellContainerProps } from "./types";
import { StyledCellContainer } from "./styles";

export const CellContainer = ({ children, align = "start", direction, gap }: CellContainerProps) => {
  return (
    <StyledCellContainer
      align={align}
      direction={direction}
      gap={gap}
    >
      {children}
    </StyledCellContainer>
  );
};

CellContainer.displayName = "CellContainer";
